<template>
  <router-view />
</template>

<script setup>
defineOptions({
  name: 'BillingLayout'
})
</script>
<style lang="scss" scoped></style>
